import gql from 'graphql-tag';

export const GET_TERMS_AND_CONDITIONS = gql`
query GET_TERMS_AND_CONDITIONS($country: String!) {
  terms_and_conditions(where: {country: {_eq: $country}, active: {_eq: true}}) {
    terms
    id
  }
}
`;

export const ALERT_ACCEPTANCE_OF_TERMS_AND_CONDITIONS = gql`
query alertOfAcceptanceOfTermsAndConditions {
  alertTermsAccepted {
    error
    msg
  }
}
`;

export const areTermsAndConditionsRequired = gql`
query areTermsAndConditionsRequired($tax_id: String!, $userID: uuid!) {
  organization(where: {tax_id: {_eq: $tax_id}}) {
    requires_terms_acceptance
    newProvider
    terms_and_conditions_id
    country
  }
  user(where: {id: {_eq: $userID}}) {
    terms_and_conditions_viewed
    contact_type
  }
}
`;

export const areTyCRequired = gql`
query areTyCRequired {
  organization {
    requires_terms_acceptance
    newProvider
    terms_and_conditions_id
    country
  }
  user {
    terms_and_conditions_viewed
    contact_type
  }
}
`;

export const GET_FORM_DATA = gql`
query GET_FORM_DATA($organization_id: uuid!, $user_id: uuid!) {
  organization_contact(where: {organization: {id: {_eq: $organization_id}}}) {
    id
    name
    last_name
    role
    email
    phone
    contact_type
  }
  organization(where: {id: {_eq: $organization_id}}) {
    tax_id
    country
    client_type
    name
    address
    description
    contact_name
    contact_email
  }
  user(where: {id: {_eq: $user_id}}) {
    first_name
    last_name
    email
    role
    phone
  }
}
`;

export const GET_TERMS_AND_CONDITION_BY_ID_OR_COUNTRY = gql`
query GET_TERMS_AND_CONDITION_BY_ID_OR_COUNTRY($country: String, $idTerms: Int = 10, $active: Boolean = true) {
  terms_and_conditions(where: {country: {_eq: $country}, active: {_eq: $active}, id: {_eq: $idTerms}}) {
    id
    published
    terms
    active
    country
  }
}
`;

export const GET_ACCEPTED_TERMS_CONDITIONS = gql`
  query GET_ACCEPTED_TERMS_CONDITIONS($organizationID: uuid!) {
    organization_accepted_terms(where: {organization_id: {_eq: $organizationID}}, order_by: {acceptance_date: desc}) {
      acceptance_date
      user {
        email
        first_name
      }
      terms_and_condition {
        id
        terms
      }
    }
  }
`;

export const GET_ORGANIZATION_ACCEPTED_LATEST_TERMS = gql`
  query GET_ORGANIZATION_ACCEPTED_LATEST_TERMS($organizationID: uuid!) {
    organization_accepted_terms(where: {organization_id: {_eq: $organizationID}}, order_by: {acceptance_date: desc}, limit: 1) {
      acceptance_date
      terms_and_condition {
        id
        terms
      }
    }
  }
`;

export const SHOW_RED_GLOBE_NOTIFICATION = gql`
  query SHOW_RED_GLOBE_NOTIFICATION($date: timestamp!, $tax_id: String!) {
    redGlobeNotification: organization_accepted_terms(where: {acceptance_date: {_gte: $date}, organization: {tax_id: {_eq: $tax_id}}}, limit: 1) {
      acceptance_date
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/termsAndConditions.js